import { httpGet, httpPost } from '../../../utils/api.utils';
import { USER_ROLES_ID as userRoles } from '../../../utils/constant.utils';
import {
    getNavItems, setAllSubs, updateActiveKey,
    getBurgeMenuUrls, getNewNavItems
} from '../../../../app/constants/model-reducers/external/nav-menu/nav-menu.settings';

const initialState = {
    navItems: [],
    newNavItems: [],
    isSubsLoaded: false,
    isSubsError: false,
    activeKey: 0,
    subsUnderLineManager: [],
    burgerMenuUrls: [],
};

export const navMenuActions = {
    fetchBurgerMenuUrls: () => async (dispatch) => {
        const data = await httpGet('external/nav/getBurgerMenuUrls')
        dispatch({
            type: getBurgeMenuUrls,
            burgerMenuUrls: data
        });
    },
    fetchNavItems: () => async (dispatch, getState) => {
        const data = getState().navMenu.subsUnderLineManager;
        const url = 'external/nav/getNavMenus';
        const navItems = await httpPost(url, data);

        dispatch({
            type: getNavItems,
            navItems: navItems,
        });
        return true;
    },
    fetchNewNavItems: () => async (dispatch, getState) => {
        const data = {
            otherSubscribers: getState().navMenu.subsUnderLineManager
            , EId: sessionStorage.EID
        }
        const url = 'external/nav/getNewNavMenus';
        const newNavItems = await httpPost(url, data);

        dispatch({
            type: getNewNavItems,
            newNavItems: newNavItems,
        });
        return true;
    },
    updateActiveKey: activeKey => (dispatch, getState) => {
        dispatch({ type: updateActiveKey, activeKey: activeKey });
    },
    setSubsUnderLM: () => async (dispatch, getState) => {
        const isManager = (sessionStorage.UserRoleID == userRoles.manager || sessionStorage.UserRoleID == userRoles.lineManager);
        let subsUnderLineManager = [];
        if (isManager) {
            const empId = JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId;
            subsUnderLineManager = await httpGet(`external/otherSubscribers/getAllLevelSubscribers/${empId}`);
        }

        const subsReady =  isManager && subsUnderLineManager.ok === false;
        dispatch({
            type: setAllSubs,
            isSubsLoaded: true,
            isSubsError: subsReady,
            subsUnderLineManager: subsReady ? [] : subsUnderLineManager
        });
        return true;
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getNavItems:
            return {
                ...state,
                navItems: action.navItems
            };
        case getNewNavItems:
            return {
                ...state,
                newNavItems: action.newNavItems
            };
        case setAllSubs:
            return {
                ...state,
                isSubsLoaded: action.isSubsLoaded,
                isSubsError: action.isSubsError,
                subsUnderLineManager: action.subsUnderLineManager
            };
        case updateActiveKey:
            return {
                ...state,
                activeKey: action.activeKey
            };
        case getBurgeMenuUrls:
            return {
                ...state,
                burgerMenuUrls: action.burgerMenuUrls
            };
        default:
            return state;
    }
};
